import React, { memo } from "react";

import { classNames } from "helpers";

import { DOCUMENT_DRAFT_STATUS, DOCUMENT_LABELS, DOCUMENT_SAMPLE_AMOUNTS, STATUS_TONE_CLASSES } from "../consts";
import { DocumentHeroCardProps } from "../types";

/**
 * Velika kartica dokumenta: vrsta i broj, pečat statusa, kupac, vozilo i iznos. Predložak još
 * nema broj ni iznos, a storniran dokument je prekrižen.
 */
const DocumentHeroCard: React.FC<DocumentHeroCardProps> = ({ documentType, isRent, scene, statusId }) => {
  const labels = DOCUMENT_LABELS[documentType];
  const amount = isRent ? DOCUMENT_SAMPLE_AMOUNTS.rent : DOCUMENT_SAMPLE_AMOUNTS.sale;
  const isDraft = statusId === DOCUMENT_DRAFT_STATUS;
  const isCancelled = statusId === "cancelled";

  return (
    <div className={classNames("relative h-full p-5", isCancelled ? "opacity-70" : "")}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">
            {isRent ? labels.rent : labels.sale}
          </div>
          {isDraft ? (
            <div className="mt-1.5 h-3 w-28 rounded-full bg-slate-200" />
          ) : (
            <div className={classNames("text-sm font-bold text-slate-800", isCancelled ? "line-through" : "")}>
              {labels.number}
            </div>
          )}
        </div>
        <span
          className={classNames(
            "px-2 py-0.5 rounded-full text-[0.65rem] font-semibold flex-shrink-0",
            STATUS_TONE_CLASSES[scene.tone].badge
          )}
        >
          {scene.badge}
        </span>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <span className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-xs font-bold text-blue-700 flex-shrink-0">
          MH
        </span>
        <div className="min-w-0">
          <div className="text-xs font-semibold text-slate-700">Marko Horvat</div>
          <div className="text-[0.65rem] text-slate-400 truncate">marko.horvat@orytron.com</div>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-3 rounded-md bg-slate-50 p-2">
        <div className="flex items-center justify-center w-16 h-10 p-1 rounded-sm bg-gradient-to-br from-amber-200 to-amber-300 flex-shrink-0">
          <img src="/media/images/vehicles/vehicle-3.png" alt="" className="w-full h-full object-contain" />
        </div>
        <div>
          <div className="text-[0.7rem] font-semibold text-slate-700">Kia Sorento</div>
          <div className="text-[0.65rem] text-slate-400">ZG 1234 AB</div>
        </div>
      </div>

      <div className="absolute inset-x-5 bottom-5 flex items-end justify-between border-t border-slate-100 pt-3">
        <span className="text-[0.7rem] text-slate-400">{amount.label}</span>
        {isDraft ? (
          <span className="h-4 w-24 rounded-full bg-slate-200" />
        ) : (
          <span className={classNames("text-xl font-bold text-slate-800", isCancelled ? "line-through" : "")}>
            {amount.value}
          </span>
        )}
      </div>

      {/* Pečat preko storniranog dokumenta. */}
      {isCancelled && (
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-12 rounded-md border-4 border-rose-500 px-3 py-1 text-lg font-extrabold uppercase tracking-widest text-rose-500">
          Storno
        </span>
      )}
    </div>
  );
};

export default memo(DocumentHeroCard);
